<template>
  <v-container>
    <v-card>
      <v-card-title>
        Статистика по месяцам
        <v-spacer></v-spacer>
        <v-autocomplete
          label="Сайт"
          v-model="site"
          :items="sitesSelectData"
        ></v-autocomplete>
      </v-card-title>
      <v-card-text style="position: flex; ">
        <div style="max-width: 600px; margin: 0 auto;"><bar-chart :chart-data="monthsData"></bar-chart></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import BarChart from './BarChart.js';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'months-charts',
  components: {
    BarChart
  },
  data() {
    return {
      site: null
    }
  },
  created() {
    this.$store.dispatch('sites/loadList');
    this.$store.dispatch('customers/loadStat');
  },
  mounted() {
    
  },
  methods: {
  
  },
  computed: {
    ...mapGetters('customers', ['statPerMonth', 'statMonths']),
    sitesSelectData() {
      return [
        {
          value: null,
          text: 'ВСЕ САЙТЫ'
        },
        ...this.$store.getters['sites/sitesSelectData']
      ]
    },
    monthsData() {
      return  {
        labels: this.statMonths.filter((x, ind) => ind != this.statMonths.length - 1).map(x => x.text),
        datasets: [{
          label: 'Всего новых клиентов',
          backgroundColor: 'rgba(8, 192, 247, 0.5)',
          borderColoe: 'rgba(32, 8, 247, 0.9)',
          borderWidth: 2,
          data: this.statPerMonth.filter((x, ind) => ind != this.statMonths.length - 1).map(mData => {
            let sData = mData.find(x => x.siteId == this.site);
            return sData['allCount'];
          })
        }]
      };
      
    }
  }
}
</script>